import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
interface Notification {
  flagCode: string;
  countryName: string;
  location: string;
  name: string;
  initials: string;
  time: string;
}
const notifications: Notification[] = [{
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Ryan Keller',
  initials: 'RK',
  time: '12 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Jade Palmer',
  initials: 'JP',
  time: '18 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'Austin, United States',
  name: 'Marisol Reyes',
  initials: 'MR',
  time: '27 minutes ago'
}, {
  flagCode: 'nz',
  countryName: 'New Zealand',
  location: 'Auckland, New Zealand',
  name: 'Daniel Grant',
  initials: 'DG',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimer = setTimeout(() => setIsVisible(true), 3000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-218" data-mp="3krc4jmz8g3xl">
      <AnimatePresence mode="wait" data-id="element-219" data-mp="3at4s9hfw2a1x">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} className="bg-paper border border-warmgray rounded-xl p-3.5 shadow-[0_10px_30px_-14px_rgba(51,47,43,0.35)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-220" data-mp="3auporclrk32f">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-charcoal-muted hover:text-charcoal transition-colors duration-150 ease-out" aria-label="Dismiss notifications" data-id="element-221" data-mp="2n54zyd2xibl8">
              <X size={14} aria-hidden="true" data-id="element-222" data-mp="2dgq0az5cjn6s" />
            </button>

            <div className="flex items-center gap-3" data-id="element-223" data-mp="28fabcw01swj4">
              <div className="relative shrink-0" data-id="element-224" data-mp="2ndmbjcmmqnf1">
                <div className="w-11 h-11 rounded-full bg-terracotta text-paper flex items-center justify-center font-bold text-sm" data-id="element-225" data-mp="2ncb5t79mj5la">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Flag of ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-paper" data-id="element-226" data-mp="2w4uy7pzbodxo" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-227" data-mp="316bwreuc3ob3">
                <div className="text-[11px] text-charcoal-muted mb-0.5 truncate" data-id="element-228" data-mp="3l73pp0f89zae">
                  {current.location}
                </div>

                <p className="text-charcoal text-[13px] leading-snug" data-id="element-229" data-mp="3p7npkbr6rh08">
                  <span className="font-bold" data-id="element-230" data-mp="3tyxbb19m606u">{current.name}</span>{' '}
                  <span className="text-charcoal-soft" data-id="element-231" data-mp="3u1rw4twjhn0s">
                    purchased Massage Therapist Ready
                  </span>
                </p>

                <div className="flex items-center gap-1.5 text-[10px] text-terracotta-dark font-medium mt-1" data-id="element-232" data-mp="329kqeoiknv16">
                  <ShoppingBag size={10} aria-hidden="true" data-id="element-233" data-mp="36acznhrg1zxg" />
                  <span data-id="element-234" data-mp="3b8eic1kyjx8e">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}